import { DeepPartial, ResultsGridConfig } from '@empathybroker/ebx-gluon';

export const DESKTOP_RESULTS_GRID_CONFIG: DeepPartial<ResultsGridConfig> = {
  grid: {
    columns: 4
  },
  components: {
    gridItem: {
      Blog: 'TuandcoBlogResults'
    } as any
  }
};

export const MOBILE_RESULTS_GRID_CONFIG: DeepPartial<ResultsGridConfig> = {
  components: {
    gridItem: {
     Blog: 'TuandcoBlogResults'
    } as any
  }
};
